import React from 'react';

import { TemplateEdit } from '@weezevent/templar';

const TemplateEdition = ({ id, organizationId = 0 }) => {
    return <TemplateEdit id={id} organizationId={organizationId} redirectionAction={`/emails/templates/templates/${id}`} />;
};

export default TemplateEdition;
